import React from "react";
import { DailyTaskDetailReportTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.dataOne;
        const contentRowNames = this.props.rowNames;
        const keys = this.props.keys;


        return (

            <div>

                <center>{searchData.group}</center>
                <center><u>Sundry</u></center>
                <center><u>Labour Check List</u></center>

                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division == undefined ? "All Collection Points" : searchData.division}</div>
                    <div className="col"><b>Field No: </b> {searchData.field == undefined ? "All Fields" : searchData.field}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="row pl-2 pb-4 ">
                    <div className="col"><b>Field Supervisor Name: </b></div>
                    <div className="col"><b>Signature:</b></div>
                </div>


                {
                    keys.map((e, index) => {
                        return (
                            <div key={index} className="row pt-2">
                                <div className="col width4">
                                    <table className="display dataTable no-footer" id={e}>
                                        <thead>
                                            <tr>
                                                <th>Employee No</th>
                                                <th>Employee Name</th>
                                                <th>Work Code</th>
                                                <th>Description Of Work</th>
                                                <th>Time In</th>
                                                <th>Time Out</th>
                                                <th>Duration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <DailyTaskDetailReportTableContent
                                                data={data[e]}
                                                contentRowNames={contentRowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                    </table>
                                    <div className="row pl-3 pt-4 "><b>Total Number of workers : {contentRowNames.length} </b></div>
                                </div>
                            </div>
                        )
                    })
                }
            </div >
        );
    }
}